exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.recover-container[data-v-57b26676]{width:270px;margin:96px auto;display:block;padding:48px 0\n}\n.recover-container input[data-v-57b26676],.recover-container button[data-v-57b26676]{display:block;width:100%;margin:12px 0\n}\n.recover-container input[data-v-57b26676]{padding:6px\n}\n.recover-container button[data-v-57b26676]{padding:9px 0;border:none;color:#fff;background-color:#fecc39;cursor:pointer\n}\n.recover-container button.disabled[data-v-57b26676]{opacity:.5\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-57b26676","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/change_password/ChangePassword.vue
// module id = BM//
// module chunks = 1